// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"2c58eff1","662":"476a0b1f","1006":"acc4ac13","1899":"1ff44039","4688":"8c8b253c","6465":"d9ce11ff","7914":"535627fa","9737":"80bc6c19"}[chunkId] + ".chunk.css";
};